import axios from "axios"
import Zipcode from "../../models/Zipcode"

class ZipcodeApi {
  private axiosInstance = axios.create({
    baseURL: `${process.env.VUE_APP_CHECKOUT_API}/ck/zipcode`,
  });

  async get(zipcode: string): Promise<Zipcode> {
    const { data } = await this.axiosInstance.get(`/${zipcode}`)
    return new Zipcode(data)
  }
}

export default new ZipcodeApi()
